import React from 'react';
import DesignCard from '../../DesignCard';

export interface InlinePageImageRowProps {
    urls: string[];
}

export default function InlinePageImageRow({ urls }: InlinePageImageRowProps) {
    return (
        <div className="inline-page-image-row">
            {urls.map((url, index) => (
                <div key={index} className="inline-page-image-row__image">
                    <DesignCard
                        variations={['lazyload', 'small', 'low-shadow']}
                        width={70}
                        height={70}
                        src={url}
                        alt=""
                    />
                </div>
            ))}
        </div>
    );
}

InlinePageImageRow.calculateMaxHeightPercentage = function (): number {
    return 0.15;
};
